import httpService from "..";

export const searchProductsApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/search?search=${search}&status=Active&groupId=${groupId}`,
    "get"
  );
};

export const getProductsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product`,
    "get",
  );
};

export const getPlansApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/plans`,
    "get",
  );
};

export const getProductApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/${id}`,
    "get",
  );
};

export const getCompanyProductsApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/group/${groupId}`,
    "get",
  );
};

export const addProductApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product`,
    "post",
    data
  );
};

export const editProductApi = async (
  id: string,
  planId: any,
  categoryId: any,
  data: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/${id}?planId=${planId}&categoryId=${categoryId}`,
    "patch",
    data
  );
};

export const removeProductApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/product/${id}`,
    "delete",
  );
};
